import { Badge } from '@/components/ui/badge';

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
};

export const getDaysRemaining = (endDate) => {
  if (!endDate) return null;
  return Math.ceil((new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24));
};

export const getStatusBadge = (status) => {
  const map = {
    active: { label: 'Actif', variant: 'default' },
    returned: { label: 'Retourné', variant: 'secondary' },
    replaced: { label: 'Remplacé', variant: 'outline' },
  };
  const info = map[status] || { label: status, variant: 'outline' };
  return <Badge variant={info.variant}>{info.label}</Badge>;
};
